module.exports = __webpack_public_path__ + "media/images/official/kv_pc2-6f879c91eea0ca3d639becb5d8d6e101.webp";